import setup from './moduleSetup';

export default {
    name: 'receiveInventory',
    before: [],
    after: [],
    setup,
};
